import { jsx as _jsx } from "react/jsx-runtime";
export const Checkmark = props => {
  return /*#__PURE__*/_jsx("svg", {
    role: "presentation",
    viewBox: "0 0 15 15.343",
    xmlns: "http://www.w3.org/2000/svg",
    children: /*#__PURE__*/_jsx("path", Object.assign({}, props, {
      d: "M1.01318 8.10969C1.01318 7.88669 1.09118 7.6977 1.24718 7.5417L2.38718 6.4017C2.54218 6.2467 2.73218 6.1687 2.95518 6.1687C3.17818 6.1687 3.36818 6.2457 3.52518 6.4017L5.98518 8.8717L11.4772 3.3717C11.6332 3.2157 11.8232 3.1377 12.0452 3.1377C12.2692 3.1377 12.4582 3.2147 12.6152 3.3707L13.7532 4.5107C13.9092 4.6657 13.9872 4.8557 13.9872 5.0787C13.9872 5.3027 13.9092 5.4927 13.7532 5.6487L7.69318 11.7087L6.55318 12.8487C6.39818 13.0037 6.20818 13.0817 5.98518 13.0817C5.76218 13.0817 5.57218 13.0037 5.41518 12.8477L4.27718 11.7077L1.24718 8.6777C1.09118 8.5217 1.01318 8.3317 1.01318 8.1077V8.10969Z"
    }))
  });
};
Checkmark.displayName = 'Checkmark';